<template>
    <div class="blog-banner">
        <a class="control" @click.prevent="nextIndex(-1)"></a>
        <a class="control right" @click.prevent="nextIndex(1)"></a>
        <div class="blog-banner-slider" :style="{transform: `translateX(${transform}%)`}">
            <div v-for="(item, key) in items" :key="`blog-banner-${key}`" class="blog-banner-item"
                 :style="{backgroundImage: `url('${item.image}')`}">
                <div class="blog-banner-item-content">
                    <img src="@/assets/img/svg/articles.svg" width="18">
                    <h2>{{ item.title }}</h2>
                    <div class="description">{{ item.description }}</div>
                    <div class="author"><small>Por</small> {{ item.author }}</div>
                    <div class="date">
                        <img src="@/assets/img/svg/white_calendar.svg">
                        {{ item.date }}
                    </div>
                    <p><router-link :to="`blog/${item.slug}`" class="button button-orange is-small">LER MATÉRIA</router-link></p>
                </div>
            </div>
        </div>
        <div class="blog-banner-bullets">
            <a @click.prevent="() => currentIndex = index" class="bullet" v-for="index in indexes" :key="`bullet-${index}`" :aria-checked="currentIndex === index" :class="{active: currentIndex === index}"></a>
        </div>
    </div>
</template>

<script>
export default {

    name: 'blog-banner',

    props: ['items'],

    data() {
        return {
            currentIndex: 0,
        }
    },

    computed: {
        transform() {
            return this.currentIndex * -100;
        },

        indexes() {
            return Object.keys(this.items).map(Number);
        }
    },

    created() {
        // setInterval(this.nextIndex, 5000)
    },

    methods: {
        nextIndex(increment = 1) {
            this.currentIndex = Math.max(0, this.currentIndex + increment) % this.items.length
        }
    }
}
</script>
